import { render, staticRenderFns } from "./ContractsListV2.vue?vue&type=template&id=ef54d6e2&"
import script from "./ContractsListV2.vue?vue&type=script&lang=js&"
export * from "./ContractsListV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports